{
  "blocks": [
    {
      "id": "proc-std-testing",
      "kind": "procedure",
      "tags": ["testing", "both-partners", "lab"],
      "title": "STD testing",
      "subtitle": "Screening for sexually transmitted infections before fertility treatment",
      "body": {
        "procedureName": "STD testing",
        "category": "diagnostic",
        "description": "A panel of blood and/or urine tests that screens for sexually transmitted infections such as HIV, hepatitis B and C, syphilis, chlamydia, and gonorrhea. Required before most fertility treatments.",
        "howItWorks": "A blood sample is drawn from your arm to test for HIV, hepatitis B, hepatitis C, and syphilis. A urine sample or genital swab may also be collected to screen for chlamydia and gonorrhea. The samples are sent to a laboratory for analysis. Most clinics require both partners to be tested before starting any assisted reproduction procedure.",
        "duration": "10–15 minutes",
        "anesthesia": "none",
        "painAndComfort": [
          "Expect a brief needle pinch; a urine sample is painless and a swab may cause mild temporary discomfort."
        ],
        "whatToExpect": [
          "A standard blood draw from your arm",
          "You may also provide a urine sample or have a swab taken",
          "Results are usually available within 3–7 business days",
          "If any result is positive, your care team will discuss treatment options and how it affects your fertility plan",
          "Negative results are typically valid for 6–12 months depending on clinic policy"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "Most STI screening results return within 3-7 business days, though some blood tests may post sooner."
          },
          {
            "label": "If positive",
            "detail": "Your care team should explain treatment, partner testing, and whether fertility treatment needs to pause until infection is treated."
          },
          {
            "label": "Validity",
            "detail": "Negative results are often accepted for 6-12 months, but each clinic sets its own policy."
          }
        ],
        "prepInstructions": [
          "No special preparation is needed for blood tests",
          "For urine testing, avoid urinating for at least one hour before the appointment",
          "Both partners should plan to be tested",
          "Bring a list of any current medications"
        ],
        "risks": [
          "Minor bruising at the blood draw site",
          "Mild discomfort during a swab collection"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Dépistage des IST",
          "description": "Bilan sanguin et/ou urinaire dépistant les infections sexuellement transmissibles (IST) : VIH, hépatites B et C, syphilis, chlamydia et gonocoque. Obligatoire avant la plupart des traitements d'AMP (assistance médicale à la procréation).",
          "howItWorks": "Une prise de sang au bras permet de tester le VIH, l'hépatite B, l'hépatite C et la syphilis. Un échantillon d'urine ou un prélèvement génital peut également être recueilli pour la recherche de chlamydia et de gonocoque. Les échantillons sont envoyés au laboratoire. La plupart des centres exigent que les deux partenaires soient testés avant toute procédure d'AMP.",
          "duration": "10 à 15 minutes",
          "whatToExpect": [
            "Prise de sang standard au bras",
            "Vous pouvez également fournir un échantillon d'urine ou faire un prélèvement",
            "Résultats généralement disponibles sous 3 à 7 jours ouvrés",
            "Si un résultat est positif, votre équipe vous présentera les options thérapeutiques et les conséquences pour votre projet",
            "Les résultats négatifs sont généralement valables 6 à 12 mois selon la politique du centre"
          ],
          "prepInstructions": [
            "Aucune préparation particulière pour les analyses sanguines",
            "Pour l'analyse d'urine, n'urinez pas dans l'heure précédant le rendez-vous",
            "Les deux partenaires doivent être testés",
            "Apportez la liste de vos traitements en cours"
          ],
          "risks": [
            "Léger hématome au point de prélèvement",
            "Léger inconfort lors d'un prélèvement par écouvillon"
          ]
        }
      },
      "sources": [
        {
          "title": "Sexually Transmitted Infections Treatment Guidelines, 2021",
          "authors": "Workowski KA, Bachmann LH, Chan PA, et al.",
          "journal": "MMWR Recommendations and Reports",
          "year": 2021,
          "url": "https://www.cdc.gov/std/treatment-guidelines/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Recommendations for reducing the risk of viral transmission during fertility treatment with the use of autologous gametes",
          "authors": "Practice Committee of the ASRM",
          "journal": "Fertility and Sterility",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "proc-std-testing",
      "to": "test-infectious-disease",
      "type": "related-to",
      "label": "Procedure used for"
    }
  ],
  "localeVariants": []
}
